export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-black/15 bg-bone"
        >
            <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-8 flex items-center justify-center">
                <p
                    data-testid="footer-copyright"
                    className="font-mono text-[10px] tracking-[0.22em] uppercase text-quiet"
                >
                    © 2026 Denis Catapano — All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
